const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "CANDID nearly means",
    options: ["A. Deceptive", "B. Frank", "C. Reserved", "D. Cautious"],
    answer: "B"
  },
  {
    id: 92,
    question: "Choose the antonym of GENEROUS.",
    options: ["A. Kind", "B. Charitable", "C. Liberal", "D. Stingy"],
    answer: "D"
  },
  {
    id: 93,
    question: `Choose the correct meaning of the phrase "to bite the bullet".`,
    options: ["A. To face a difficult situation bravely", "B. To speak angrily to someone", "C. To waste an opportunity", "D. To avoid a confrontation"],
    answer: "A"
  },
  {
    id: 94,
    question: `Choose the correct word to complete the sentence:
    Despite the heavy rain, the match was so __________ that the crowd stayed till the end.`,
    options: ["A. Dull", "B. Tedious", "C. Thrilling", "D. Monotonous"],
    answer: "C"
  },
  {
    id: 95,
    question: "Choose the sentence which is grammatically correct.",
    options: ["A. Neither of the answers is correct.", "B. Neither of the answers are correct.", "C. Neither of the answer is correct.", "D. Neither of the answers were correct."],
    answer: "A"
  },
  {
    id: 96,
    question: `Choose the passive form of the following sentence:
    "The workers are repairing the road."`,
    options: ["A. The road is repaired by the workers.", "B. The road was repaired by the workers.", "C. The road has been repaired by the workers.", "D. The road is being repaired by the workers."],
    answer: "D"
  },
  {
    id: 97,
    question: `Read the sentence and choose the word with the correct spelling from the options given.
    The committee will __________ the proposal next week.`,
    options: ["A. scrutinize", "B. scrutinise", "C. scruitinize", "D. scrutinnize"],
    answer: "B"
  },
  {
    id: 98,
    question: `Match the following List-I (verb forms) with List-II (non-finites):
    List-I: (a) Present participle  (b) Infinitive  (c) Gerund  (d) Past participle
    List-II: (i) Base form of a verb often preceded by "to"  (ii) Verb form ending in -ing used as an adjective or continuous tense  (iii) Verb form used as a noun without "to"  (iv) Form showing a completed action, often ending in -ed/-en`,
    options: ["A. a-ii, b-i, c-iii, d-iv", "B. a-i, b-ii, c-iv, d-iii", "C. a-iii, b-iv, c-i, d-ii", "D. a-iv, b-iii, c-ii, d-i"],
    answer: "A"
  },
  {
    id: 99,
    question: `Read the following passage and answer the question:
    Working from home has become increasingly common in the last decade. While it offers flexibility and saves commuting time, it can also blur the boundary between personal and professional life. Employees often report working longer hours than they would in an office, since there is no clear moment to "leave" work behind.
    What is one disadvantage of working from home mentioned in the passage?`,
    options: ["A. It increases commuting time", "B. It reduces flexibility for employees", "C. It can blur the boundary between personal and professional life", "D. It has become less common recently"],
    answer: "C"
  },
  {
    id: 100,
    question: `Direction: Read the sentence to find out whether there is any error in it. The error, if any, will be in one part of the sentence. The alphabet number of that part is the answer.
    He has been / working here / since / three years.`,
    options: ["A. A", "B. B", "C. C", "D. D"],
    answer: "C"
  }

];

export default pgcetmcaGeneralEnglish;